module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="center">Merge '+
((__t=( mode ))==null?'':__t)+
' <a href="/#person/'+
((__t=( personId ))==null?'':__t)+
'" target="_blank">'+
((__t=( personName ))==null?'':__t)+
'</a></h4>\r\n\r\n<div class="table-responsive well" style="font-size: 10px;">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Owner</th>\r\n            <th>Org.</th>\r\n            <th title="Can View">CV</th>\r\n            <th title="Can Read All">CRA</th>\r\n            <th title="Can Read For">CRF</th>\r\n            <th title="Can Edit">CE</th>\r\n            <th title="Can Edit For">CEF</th>\r\n            <th title="Can Edit All">CEA</th>\r\n            <th title="Can Delete">CD</th>\r\n            <th title="Can Sign">CS</th>\r\n            <th title="Can Sign For All">CSFA</th>\r\n            <th title="Can Upload For">CUF</th>\r\n            <th title="Can Change Reviewer">CCR</th>\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
 _.each(permissions, function(permission, index) { 
__p+='\r\n        <tr ';
 if (mode == 'to' && !isMergedPermission(permission) || mode == 'from' && isDeprecated(permission)) { 
__p+=' class="deprecated-header" ';
 } 
__p+=' >\r\n\r\n            ';
 if (permission.ownerId != null && permission.owner != null) { 
__p+='\r\n                <td><a href = "/#person/'+
((__t=( permission.ownerId ))==null?'':__t)+
'">'+
((__t=( formatPerson(permission.owner.object) ))==null?'':__t)+
'</a></td>\r\n            ';
 } else { 
__p+='\r\n                <td>-</td>\r\n            ';
 } 
__p+='\r\n            ';
 if (permission.organizationId != null && permission.organization != null) { 
__p+='\r\n                <td><a href = "/#organization/'+
((__t=( permission.organizationId ))==null?'':__t)+
'">'+
((__t=( permission.organization.name ))==null?'':__t)+
'</a></td>\r\n            ';
 } else { 
__p+='\r\n                <td>-</td>\r\n            ';
 } 
__p+='\r\n\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canRead" ';
 if (permission.canRead) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadAll" ';
 if (permission.canReadAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadFor" ';
 if (permission.canReadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWrite" ';
 if (permission.canWrite) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteFor" ';
 if (permission.canWriteFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteAll" ';
 if (permission.canWriteAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canDelete" ';
 if (permission.canDelete) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSign" ';
 if (permission.canSign) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSignAll" ';
 if (permission.canSignAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canUploadFor" ';
 if (permission.canUploadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canChangeReviewer" ';
 if (permission.canChangeReviewer) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n\r\n\r\n            ';
 if (mode == 'from') { 
__p+='\r\n            <td id="'+
((__t=( index ))==null?'':__t)+
'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
((__t=( isHidden(permission) ))==null?'':__t)+
'" id="'+
((__t=( permission.id ))==null?'':__t)+
'" title="Add"></span></td>\r\n            ';
 } 
__p+='\r\n            ';
 if (mode == 'to') { 
__p+='\r\n            <td id="'+
((__t=( index ))==null?'':__t)+
'"><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
((__t=( permission.id ))==null?'':__t)+
'" title="Remove"></span></td>\r\n            ';
 } 
__p+='\r\n        </tr>\r\n        ';
 }) 
__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/merge-person-permissions-view.html
// module id = 497
// module chunks = 0